import React, {useContext } from 'react';
import {Link} from "react-router-dom";
import WhatsappButton from "../../Components/WhatsappButton";
import styled from "styled-components";
import Horarios from '../../Components/Lista/Horarios';
import AppContext from '../../Context/AppContext';

const Container=styled.div`
position: absolute;
top:0;
bottom: 0;
left: 0;
right: 0;
margin: auto;
display:grid;
justify-content:center;
align-content:center;
`;

const Logo=styled.img`
margin-bottom: 1.2rem;
justify-self:center;
object-fit:contain;
height:50px;
`;

const Text=styled.p`
height:100%;
padding:0 22.5px;
font-size:24px;
margin-top:10px;
font-size:20px;
text-align:center;`;

const SubText=styled.h3`
text-align:center;
margin:0;
margin-top: 1rem;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}
`;

const Button=styled.button`
margin: 15px auto;
font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
font-size:26px;
font-weight:700;
border-radius:6px;
border:none;
height: 54px;
width: 300px;
margin-bottom: 0;
color:white;
outline:none;
background-color: rgb(0, 136, 255);
cursor:pointer;
@media screen and (max-width:428px)
{
  
}`;

const StyledLink=styled(Link)`
justify-self: center;
text-decoration:none;
`;


const Confirmado=()=>
{
    const {Customer}=useContext(AppContext);
    const {name,count,docID}=Customer;
    const logo    = <Logo src={"https://firebasestorage.googleapis.com/v0/b/waitwhile-app.appspot.com/o/images%2Faccounts%2F3q2SXkB2XwCwg2a914W9%2F62b4db43-63b9-4629-896f-27dc90d46f77.jpg?alt=media&token=4d305a05-e0da-4658-b42b-2ef93f35d975"} alt={`Logo de Baum Lanús`}/>;


    const Link=`/lista/${docID}`;

    return <Container>
    {logo}
    <Text style={{marginTop:"8px", padding:"0px 10px"}}>Ya están anotados! <span role="img" aria-label="Emoji feliz">😃</span> </Text>
    <Text style={{marginTop:"8px", padding:"0px 10px"}}> Los llamaremos a nombre de {name} (x{count})</Text>
    <Text style={{fontWeight:"bold"}}><span role="img" aria-label="Emoji alerta">⚠️</span> Estar presentes cuando sean los proximos sino tenemos que liberar la mesa! </Text>

    <StyledLink to={Link}> <Button>Ver posición</Button> </StyledLink>
    <Horarios/>
    <WhatsappButton number="5491138141940" show={true} bottom={10}/>
</Container> 
}

export default Confirmado;